module.exports = __webpack_public_path__ + "img/bg.ed681c3d.png";